import { useEffect, useState } from "react";
import { coloringApi } from "./api.js";
import { useColoring } from "./ColoringContext.js";
import type { ProviderStatus } from "./types.js";

/**
 * Image-provider status (which are connected, which is active, and what the
 * active one can do). Refetched when the book's chosen provider changes. Null
 * while loading or if the lookup fails.
 */
export function useProviderStatus(): ProviderStatus | null {
  const { projectId, state } = useColoring();
  const [status, setStatus] = useState<ProviderStatus | null>(null);
  useEffect(() => {
    let alive = true;
    coloringApi
      .providers(projectId)
      .then((s) => alive && setStatus(s))
      .catch(() => alive && setStatus(null));
    return () => {
      alive = false;
    };
  }, [projectId, state.book.imageProvider]);
  return status;
}
